import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse, IRootState} from "../../../../types";
import {
    deletedRestoreStructure,
    deletedStructure,
    setAcademicStructure, setStructureRestoreData, setStructureSettings,
    updateStructure
} from "./academicStructureSlice";
import {IAcademicStructureCreate, IAcademicStructurePayload, IStructureSettingsCreate} from "../types";



const GetAcademicStructure = createAsyncThunk(
    "get/educational/units",
    async (_, { dispatch,rejectWithValue,getState }) => {
        try {
            const response = await request.get("/educational-units");
            const lang = getState()  as IRootState
            const defaultLanguage = lang.languages.defaultLanguage
            dispatch(setAcademicStructure({data:response.data,defaultLanguage}));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const SetStructure = createAsyncThunk(
    "create/structure",
    async ( data : IAcademicStructureCreate,{rejectWithValue}) => {
        try {
            const response = await request.post("/educational-units", data);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);

const DeleteStructure = createAsyncThunk(
    "delete/structure",
    async ( id : number, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.delete(`/educational-units/${id}`);

            dispatch(deletedStructure(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);
const EditStructure = createAsyncThunk(
    "edit/structure",
    async ( data : IAcademicStructurePayload, {dispatch, rejectWithValue }) => {
        try {

            const response = await request.put(`/educational-units/${data.id}`, data);
            dispatch(updateStructure(response.data));
            return response.data;

        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const GetDeleteStructure = createAsyncThunk(
    "get/delete/structure",
    async (_, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.get(`/educational-units/deleted-items`);

            dispatch(setStructureRestoreData(response.data));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const RestoreDeleteStructure = createAsyncThunk(
    "restore/delete/structure",
    async (id: number, {dispatch,rejectWithValue}) => {
        try {
            const response = await request.post(`/educational-units/restore/${id}`);

            dispatch(deletedRestoreStructure(id));

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const GetStructureSettings = createAsyncThunk(
    "get/educational/units/settings",
    async (_, { dispatch,rejectWithValue }) => {
        try {
            const response = await request.get("/educational-units/settings");
            dispatch(setStructureSettings(response.data))

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const SetStructureSettings = createAsyncThunk(
    "create/Structure/settings",
    async ( data : IStructureSettingsCreate,{rejectWithValue}) => {
        try {
            const response = await request.post("/educational-units/settings", data);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const EditStructureSettings = createAsyncThunk(
    "edit/Structure/settings",
    async ( data : IStructureSettingsCreate,{rejectWithValue}) => {
        try {
            const response = await request.put(`/educational-units/settings/${data.educational_unit_id}`, data);

            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);




export{

    GetAcademicStructure,
    SetStructure,
    DeleteStructure,
    EditStructure,
    RestoreDeleteStructure,
    GetDeleteStructure,
    GetStructureSettings,
    SetStructureSettings,
    EditStructureSettings
}
